import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a9058da2215bd00142ad13c_1788737116176_f5a11f6e/mouridoulahkhidma/src/app/login/page.tsx");
